const state = {
  zendeskScriptLoaded: false,
  salesforceScriptLoaded: false,
}

const getters = {
  zendeskChatbotReady: (state) => {
    return state.zendeskScriptLoaded || false
  },
  salesforceChatbotReady: (state) => {
    return state.salesforceScriptLoaded || false
  },
}

const mutations = {
  SET_ZENDESK_SCRIPT_STATUS: (state, status) => {
    state.zendeskScriptLoaded = status
  },
  SET_SALESFORCE_SCRIPT_STATUS: (state, status) => {
    state.salesforceScriptLoaded = status
  },
}

const actions = {
  setZendeskScriptLoadedStatus({ commit }, status) {
    commit('SET_ZENDESK_SCRIPT_STATUS', status)
  },
  setSalesforceScriptLoadedStatus({ commit }, status) {
    commit('SET_SALESFORCE_SCRIPT_STATUS', status)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
